import * as React from 'react';
import { get } from '../../../fetch-interceptor';
import { Overlay } from 'office-ui-fabric-react';
import Spinner from '../../common/Spinner';
import { SubscriptionInfo, BillingPlan, ChargebeeInstance } from './common';
import { PlansList } from './PlansList';
import { catchApiError } from '../../../store/utils';

type Props = {
    subscription?: SubscriptionInfo;
    chargebee: ChargebeeInstance | undefined;
    canManage: boolean;
    onSwitchTrialConfirmed: (planId: string) => void;
    onSuccessfulCheckout: () => void;
}

type PlansListState = {
    plans: BillingPlan[];
    isPlansLoading: boolean;
    isPlansError: boolean;
}

export const GroupedPlansList = (props: Props) => {
    const { subscription } = props;
    const [plansState, setPlansState] = React.useState<PlansListState>({ plans: [], isPlansLoading: true, isPlansError: false });
    
    React.useEffect(() => {
        get<BillingPlan[]>("api/billing/plans")
            .then(_ => setPlansState({
                plans: _,
                isPlansLoading: false,
                isPlansError: false
            }))
            .catch(catchApiError(_ => setPlansState({ plans: [], isPlansLoading: false, isPlansError: true })));
    }, []);

    if (plansState.isPlansLoading) {
        return <Overlay><Spinner /></Overlay>;
    }

    if (!subscription || plansState.isPlansError || !Object.keys(plansState.plans).length) {
        return <div className='error-wrapper'>
            <div className="error">
                <img src="https://www.chargebee.com/static/resources/brand/chargebee-logo-black.svg" alt="Chargebee" />
                <div className="error-title">Unfortunately PPM Express Plans are temporary unavailable.</div>
                <div className="error-description">Payment API is not available at the moment. Sorry for the inconvenience. Please try again later.</div>
            </div>
        </div>
    }

    return  (
        <PlansList
            {...props}
            subscription={subscription}
            plans={plansState.plans}
        />
    );
}
